import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Value } from './core/Value';
import { EVENTS } from './core/EVENTS';
import App from './App';
import { Controller } from './core/Controller';
import ErrorScreen from './windows/ErrorScreen';

import "./LoadingScreen.css";
import { Comm } from './core/comm/Comm';

require("./index.css");


// explorer updates...

Array.prototype.findIndex = function (predicate: (value: any, index: number, array: Array<any>) => boolean)
{
    for (let i = 0; i < this.length; i++)
    {
        if (predicate(this[i], i, this))
        {
            return i;
        }
    }

    return -1;
};

Array.prototype.find = function (predicate: (value: any, index: number, array: Array<any>) => boolean)
{
    for (let i = 0; i < this.length; i++)
    {
        if (predicate(this[i], i, this))
        {
            return this[i];
        }
    }

    return null;
};

String.prototype.replaceAll = function (searchValue: string | RegExp, replaceValue: string | ((substring: string, ...args: any[]) => string)): string
{
    let val: string = this as string;

    if (typeof searchValue == "string")
    {
        while (val.indexOf(searchValue) !== -1)
        {
            if (typeof replaceValue == "string")
            {
                val = val.replace(searchValue, replaceValue);
            }
            else
            {
                val = val.replace(searchValue, replaceValue(searchValue));
            }
        }
    }
    else
    {
        let match = searchValue.exec(val);
        while (match)
        {
            if (typeof replaceValue == "string")
            {
                val = val.replace(match[0], replaceValue);
            }
            else
            {
                val = val.replace(searchValue, replaceValue.apply(null, Array.from(match) as [substring: string, ...args: any[]]));
            }

            match = searchValue.exec(val);
        }
    }

    return val;
}

Object.values = function <T>(o: Record<string, T>): T[]
{
    const values: Array<T> = [];
    for (const id in o)
    {
        values.push(o[id]);
    }
    return values;
}


function copyToClipboardOld(value: string)
{
    const text = document.createElement("textarea");
    text.style.position = "fixed";
    text.style.top = "0";
    text.style.left = "0";
    text.value = value;
    document.body.appendChild(text);
    text.focus();
    text.setSelectionRange(0, text.value.length);
    document.execCommand("copy");
    document.body.removeChild(text);
}


window.copyToClipboard = function (value)
{
    try
    {
        navigator.clipboard.writeText(value).then(() =>
        {
    
        }).catch(() => {
            copyToClipboardOld(value);
        });
    }
    catch(e)
    {
        copyToClipboardOld(value);
    }
};


// explorer updates end...

window.params = {
    version: "2.1.5",
    coreURL: "core",
    clientName: "iconix",

    game_name: "",
    token: "",
    sessionHash: "",
    systemURL: "",
    lobbyurl: "",
    language: "en",
    currency: "EUR",
    apiLocation: "",
    gameID: ""
};
window.location.search.substring(1).split("&").forEach(
    function (item)
    {
        var tmp = item.split("=");
        if (tmp[0].length > 0)
        {
            params[tmp[0]] = decodeURIComponent(tmp[1]);
            if (["language"].indexOf(tmp[0]) !== -1)
            {
                params[tmp[0]] = params[tmp[0]].toLowerCase();
            }
        }
    }
);


if (config)
{
    Object.assign(params, config);
}


global.isKeyboardOpen = () => false;
global.gameName = params.game_name;
global.token = params.token;
global.sessionHash = params.sessionHash;
global.systemURL = params.systemURL;
global.lobbyurl = params.lobbyurl;
global.currency = "";


Value.getNumber(Value.ID.MIN_BET, 0, Value.Options.NoEdit);
Value.getNumber(Value.ID.MAX_BET, 0, Value.Options.NoEdit);

Value.getNumber(Value.ID.MIN_CASHOUT, -50000, Value.Options.NoEdit);
Value.getNumber(Value.ID.MAX_CASHOUT, 50000, Value.Options.NoEdit);

Value.getNumber(Value.ID.MAX_WIN, 0, Value.Options.NoEdit);

Value.getNumber(Value.ID.BALANCE, 0, Value.Options.NoEdit);


global.gotoLobby = function ()
{
    if (lobbyurl)
    {
        window.location.href = lobbyurl;
    }
};

let loaded = false;
let connected = false;
let critical_error = false;

function renderLoadingScreen()
{
    if (loaded)
    {
        return;
    }

    return (
        <div id="loadingScreen">
            <div className='fonts'>
                <div style={{ fontFamily: "ALK Sanet" }}>font1</div>
                <div style={{ fontFamily: "BPG Arial" }}>font1</div>
                <div style={{ fontFamily: "icomoon" }}>font1</div>
                <div style={{ fontFamily: "Roboto Bold" }}>font1</div>
            </div>

            <div className='logo'></div>
            <div className='container'>
                <div className='ball1'></div>
                <div className='ball2'></div>
                <div className='ball3'></div>
                <div className='ball4'></div>
            </div>
        </div>
    );
}


function renderConnectingScreen()
{
    if (connected)
    {
        return;
    }

    return (
        <div id="loadingScreen">
            <div>
                Connection...
            </div>
        </div>
    );
}


function renderCritticalError()
{
    if (!critical_error)
    {
        return null;
    }

    return <ErrorScreen />;
}

function renderApp()
{
    if (critical_error)
    {
        return null;
    }
    return <App />
}


function render()
{
    ReactDOM.render(
        <>
            {renderApp()}
            {renderConnectingScreen()}
            {renderLoadingScreen()}
            {renderCritticalError()}
        </>,
        document.getElementById('root')
    );
}


function connect()
{
    Comm.on(Comm.CONNECTION.CONNECTED, onConnect, null);
    EVENTS.on(EVENTS.GAME.CRITICAL_ERROR, onCriticalError, null);
    Controller.init(params.token, params.sessionHash, Number(params.gameID), params.systemURL);
}


function onConnect()
{
    connected = true;

    Comm.off(Comm.CONNECTION.CONNECTED, onConnect, null);

    render();
}

function onCriticalError()
{
    critical_error = true;

    render();
}

function loadDefaultLanguage()
{
    const xhr = new XMLHttpRequest();
    xhr.open("GET", "lang/en.json?version=" + version);
    xhr.responseType = "text";
    xhr.onreadystatechange = function ()
    {
        if (xhr.readyState == 4 && xhr.status == 200)
        {
            window.lang = JSON.parse(xhr.response);

            onLanguageLoaded();
        }
    };
    xhr.send();
}


function loadLanguage()
{
    const xhr = new XMLHttpRequest();
    xhr.open("GET", "lang/" + params.language + ".json?version=" + version);
    xhr.responseType = "text";
    xhr.onreadystatechange = function ()
    {
        if (xhr.readyState == 4)
        {
            if (xhr.status == 200)
            {
                try
                {
                    window.lang = JSON.parse(xhr.response);

                    onLanguageLoaded();
                }
                catch (e)
                {
                    loadDefaultLanguage();
                }

            }
            else
            {
                loadDefaultLanguage();
            }
        }
    };
    xhr.send();
}


function onLanguageLoaded()
{
    EVENTS.once(EVENTS.LOADING.COMPLETE, function ()
    {
        loaded = true;
        render();
        connect();
    });
    render();
}

loadLanguage();